import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #4f5964;
  margin: 16px 16px;
  width: 100%;
  min-height: 120px;
  align-content: center;
`;

export const WrapperTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin: 8px 0;
`;

export const WrapperFullName = styled.h2`
  font-size: 16px;
  font-weight: bold;
  margin: 8px 0;
  color: #2d3748;
`;

export const WrapperLink = styled.a`
  font-size: 18px;
  font-weight: bold;
  line-height: 26px;
  color: #4db8ff;
`;

export const WrapperDescription = styled.p`
  font-size: 14px;
  margin: 12px 0;
`;

export const WrapperDate = styled.p`
  font-size: 14px;
  margin: 12px 0;
`;